import React from "react";
import classes from "../../TournamentContainerApp.module.css";

const TournamentComponentApp = (props) => {
    let currentStatus = "";
    let currentStatusCss = "";

    if (props.ctProcessType) {
        if (props.ctProcessType === "GENERATED") {
            currentStatus = "진행예정";
            currentStatusCss = classes.to_be;
        } else if (props.ctProcessType === "CONTEST_END") {
            currentStatus = "종료";
            currentStatusCss = classes.end;
        } else {
            currentStatus = "진행중";
            currentStatusCss = classes.ing;
        }
    }

    // 대회 타입
    const typeClassMap = {
        K: classes.type_a, // 왕중왕전
        L: classes.type_b, // 이벤트 대회
        A: classes.type_c, // 고객감사 페스티벌
        B: classes.type_d, // 챔피언십 대회
        S: classes.type_b, // 시니어
    }
    const newCtType = typeClassMap[props.ctType] || classes.type_a;

    return (
        <div className={classes.card}>
            <div className={classes.title}>
                <b className={newCtType}>{props.ctTypeName}</b>
                <h3>{props.ctTitle}</h3>
                <p className={`${classes.state} ${currentStatusCss}`}>{currentStatus}</p>
            </div>
            <ul className={classes.info}>
                <li>
                    대회기간 : {props.ctStartDate} ~ {props.ctEndDate}
                </li>
                <li>
                    대회접수 : {props.ctAppStartTime} ~ {props.ctAppEndTime}
                </li>
                <li>대회지역 : {props.regionList.join("/")}</li>
            </ul>
        </div>
    );
};

export default TournamentComponentApp;
